const quickLinks = [
  { label: "今日缘分", href: "#fate" },
  { label: "盲盒番剧", href: "#blindbox" },
  { label: "随缘漫游", href: "#roam" },
  { label: "热门推荐", href: "#popular" },
  { label: "动漫分类", href: "#categories" },
  { label: "常见问题", href: "#faq" },
];

export default function Footer() {
  const go = (href: string) => {
    document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer className="relative bg-background-950 text-background-50">
      {/* CTA 区 */}
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-12 md:py-16">
        <div className="rounded-3xl bg-gradient-to-r from-primary-600 to-accent-600 px-6 py-10 md:px-12 md:py-14 text-center relative overflow-hidden">
          <div className="absolute -right-8 -top-8 w-40 h-40 rounded-full bg-background-50/10"></div>
          <div className="absolute -left-8 -bottom-10 w-52 h-52 rounded-full bg-background-50/10"></div>
          <div className="relative z-10">
            <h2 className="font-heading text-2xl md:text-4xl text-white">
              别纠结了，今天就让缘分做主
            </h2>
            <p className="mt-3 text-white/90 text-sm md:text-base">
              打开小缘动漫库，邂逅下一部对上电波的番。
            </p>
            <button
              type="button"
              onClick={() => go("#fate")}
              className="mt-6 inline-flex items-center gap-2 rounded-full bg-background-50 text-primary-700 hover:bg-background-100 text-sm md:text-base font-bold px-8 py-3.5 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-heart-3-line"></i>
              开启缘分匹配
            </button>
          </div>
        </div>
      </div>

      {/* 主体 */}
      <div className="border-t border-background-50/10">
        <div className="mx-auto max-w-7xl px-4 md:px-6 py-12 md:py-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="w-10 h-10 rounded-full bg-primary-500 text-background-50 flex items-center justify-center">
                <i className="ri-clapperboard-line text-xl"></i>
              </span>
              <span className="font-heading text-xl text-white">小缘动漫库</span>
            </div>
            <p className="mt-4 text-sm text-background-50/70 leading-relaxed">
              用缘分、惊喜与漫游，帮你轻松邂逅下一部对上电波的番，告别选择困难。
            </p>
            <div className="mt-5 flex items-center gap-3">
              {["ri-weibo-line", "ri-bilibili-line", "ri-github-line", "ri-mail-line"].map((ic) => (
                <a
                  key={ic}
                  href="mailto:support@xiaoyuan-anime.com"
                  aria-label={ic}
                  className="w-9 h-9 flex items-center justify-center rounded-full bg-background-50/10 text-background-50/80 hover:bg-primary-500 hover:text-background-50 transition-colors"
                >
                  <i className={ic}></i>
                </a>
              ))}
            </div>
          </div>

          <div>
            <h3 className="font-heading text-base text-white mb-4">快速导航</h3>
            <ul className="space-y-2.5">
              {quickLinks.map((l) => (
                <li key={l.href}>
                  <a
                    href={l.href}
                    onClick={(e) => {
                      e.preventDefault();
                      go(l.href);
                    }}
                    className="text-sm text-background-50/70 hover:text-accent-300 transition-colors cursor-pointer"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-base text-white mb-4">随缘玩法</h3>
            <ul className="space-y-2.5 text-sm text-background-50/70">
              <li className="flex items-center gap-2">
                <i className="ri-heart-3-line text-primary-400"></i>
                今日缘分匹配
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-gift-2-line text-accent-400"></i>
                盲盒番剧揭晓
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-compass-3-line text-secondary-300"></i>
                随缘漫游模式
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-fire-line text-primary-400"></i>
                热门佳作推荐
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-base text-white mb-4">联系我们</h3>
            <ul className="space-y-3 text-sm text-background-50/70">
              <li className="flex items-center gap-2.5">
                <i className="ri-mail-line text-primary-400"></i>
                support@xiaoyuan-anime.com
              </li>
              <li className="flex items-center gap-2.5">
                <i className="ri-time-line text-primary-400"></i>
                在线陪伴 · 随缘相遇
              </li>
              <li className="flex items-center gap-2.5">
                <i className="ri-heart-pulse-line text-primary-400"></i>
                让每一部好番都被看见
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-background-50/10">
        <div className="mx-auto max-w-7xl px-4 md:px-6 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-background-50/60">
          <p>© 2026 小缘动漫库 · 让缘分决定你的下一部番</p>
          <p className="flex items-center gap-1.5">
            愿你每次刷新都有新发现
            <i className="ri-heart-3-fill text-primary-400"></i>
          </p>
        </div>
      </div>
    </footer>
  );
}